"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronLeftDouble = function ChevronLeftDouble(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("path", {
    d: "M12.8683 19.1183C12.9167 19.07 12.955 19.0126 12.9812 18.9494C13.0074 18.8862 13.0208 18.8185 13.0208 18.7501C13.0208 18.6817 13.0074 18.6139 12.9812 18.5507C12.955 18.4875 12.9167 18.4301 12.8683 18.3818L6.98655 12.5001L12.8683 6.61837C12.966 6.5207 13.0208 6.38822 13.0208 6.25008C13.0208 6.11195 12.966 5.97947 12.8683 5.8818C12.7706 5.78412 12.6381 5.72925 12.5 5.72925C12.3619 5.72925 12.2294 5.78412 12.1317 5.8818L5.88171 12.1318C5.83335 12.1802 5.79499 12.2376 5.76881 12.3008C5.74264 12.364 5.72916 12.4317 5.72916 12.5001C5.72916 12.5685 5.74264 12.6362 5.76881 12.6994C5.79499 12.7626 5.83335 12.82 5.88171 12.8684L12.1317 19.1184C12.1801 19.1667 12.2375 19.2051 12.3007 19.2313C12.3639 19.2574 12.4316 19.2709 12.5 19.2709C12.5684 19.2709 12.6361 19.2574 12.6993 19.2313C12.7625 19.2051 12.8199 19.1667 12.8683 19.1183Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M17.035 19.1183C17.0833 19.07 17.1217 19.0126 17.1479 18.9494C17.174 18.8862 17.1875 18.8185 17.1875 18.7501C17.1875 18.6817 17.174 18.6139 17.1479 18.5507C17.1217 18.4875 17.0833 18.4301 17.035 18.3818L11.1532 12.5001L17.035 6.61837C17.1326 6.5207 17.1875 6.38822 17.1875 6.25008C17.1875 6.11195 17.1326 5.97947 17.035 5.8818C16.9373 5.78412 16.8048 5.72925 16.6667 5.72925C16.5285 5.72925 16.3961 5.78412 16.2984 5.8818L10.0484 12.1318C10 12.1802 9.96165 12.2376 9.93547 12.3008C9.9093 12.364 9.89583 12.4317 9.89583 12.5001C9.89583 12.5685 9.9093 12.6362 9.93547 12.6994C9.96165 12.7626 10 12.82 10.0484 12.8684L16.2984 19.1184C16.3467 19.1667 16.4042 19.2051 16.4674 19.2313C16.5305 19.2574 16.5983 19.2709 16.6667 19.2709C16.7351 19.2709 16.8028 19.2574 16.866 19.2313C16.9292 19.2051 16.9866 19.1667 17.035 19.1183Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: "white"
  }))));
};

ChevronLeftDouble.defaultProps = {
  altText: "Double Chevron Left Double",
  foregroundColor: "#2D5AB4"
};
ChevronLeftDouble.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = ChevronLeftDouble;
exports.default = _default;